import { TokenData } from "../slices/authSlice";
import jwtDecode from "jwt-decode";
import { getAccessTokenFromLocalStorage } from "../utils/localStorageAuthHelper";

export const ReadOnlyUser = () => {

  const token = getAccessTokenFromLocalStorage();
  const decodedToken = jwtDecode<TokenData>(token.access_token);
  const tokenProperties = {
    roles: "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
  };
  decodedToken.roles = decodedToken[tokenProperties.roles as keyof typeof decodedToken] as string[];
  localStorage.setItem("read-only", "false");
  if(decodedToken.roles[0] === 'Read Only') {
    localStorage.setItem("read-only", "true");
    }
  };

export const GetReadOnlyStatus = () => {

  const str = localStorage.getItem("read-only");
  if (str !== null) {
      // Convert the string to a boolean
      const bool: boolean = str.toLowerCase() === "true";
      return bool;
  } else {
      return false;
  }
}